<template>
	<div class="image_content">
		<!-- <img src="" alt=""> -->
		<!-- <CopyrightBottom></CopyrightBottom> -->
        <div class="image_cover" v-show="showCover" @click="cover_click"></div>
        <a class="file_item_content" v-show="!showCover" v-for="(file,key) in files" :key="key" href="javascript:;" @click.prevent="file_click(file)">
            <img :src="file.image" alt="">
            <p>{{file.name}}</p>
            <p id="click_btn">点击下载</p>
        </a>
	</div>
</template>

<script type="text/javascript">
	import Vue from "vue";
    import store from '@/store/index.js';
    // import FileSaver from 'file-save';
    import { saveAs } from 'file-saver';

    var QUEST_DONE_KEY = 'dowa_profile_quest_done';
    var PENDING_DOWNLOAD_KEY = 'dowa_pending_download';

	export default{
		name:"profileDownload",
		data(){
			return{
                showCover:false,
                files:[
                    {
                        image:"https://resources.xycoder.com/dowa/pdf.png",
                        name:"DMT Alloy Guide",
                        path:"https://resources.xycoder.com/dowa/DMT Alloy Guide.pdf"
                    },
                    {
                        image:"https://resources.xycoder.com/dowa/pdf.png",
                        name:"2026PCIM资料",
                        path:"https://resources.xycoder.com/dowa/2026PCIM%E8%B5%84%E6%96%99.pdf"
                    }
                ]
			}
		},
		computed:{
			allProductDate(){
				return store.state.product_data;
			}
		},
        mounted() {
            store.state.showNavi = true;
            var ua = navigator.userAgent.toLowerCase();
            var isWeixin = ua.indexOf('micromessenger') !== -1;
            if (isWeixin) {
                this.showCover = true;
            } else {
                this.tryPendingDownload();
            }
        },
		methods:{
            hasSubmittedQuest(){
                return !!localStorage.getItem(QUEST_DONE_KEY);
            },
            file_click(filedate){
                if (!this.hasSubmittedQuest()) {
                    sessionStorage.setItem(PENDING_DOWNLOAD_KEY, JSON.stringify(filedate));
                    this.$router.push({ path: '/questionnaire', query: { from: 'download' } });
                    return;
                }
                this.startDownload(filedate);
            },
            startDownload(filedate){
                var ua = navigator.userAgent.toLowerCase();
                var isWeixin = ua.indexOf('micromessenger') !== -1;
                if (isWeixin) {
                    this.showCover = true;
                    return;
                }
                this.doDownload(filedate);
            },
            doDownload(filedate){
                var oReq = new XMLHttpRequest();
                var URLToPDF = filedate.path;
                oReq.open("GET", URLToPDF, true);
                oReq.responseType = "blob";
                oReq.onload = function() {
                    var file = new Blob([oReq.response], {
                        type: 'application/pdf'
                    });
                    saveAs(file, filedate.name);
                };
                oReq.send();
            },
            tryPendingDownload(){
                if (!this.hasSubmittedQuest()) {
                    return;
                }
                var pending = sessionStorage.getItem(PENDING_DOWNLOAD_KEY);
                if (!pending) {
                    return;
                }
                sessionStorage.removeItem(PENDING_DOWNLOAD_KEY);
                try {
                    this.doDownload(JSON.parse(pending));
                } catch (e) {
                    console.log(e);
                }
            },
            cover_click(){
                store.state.showNavi = true
                this.showCover = false
            }
        },
        watch: {
			allProductDate:{
				immediate:true,
				deep:true,
				handler:function(newValue,oldValue){
					var self = this;
					if (newValue == null || newValue.config == null) {
						 return
					 }
					//  console.log(newValue)
					self.companyImg = newValue.config.contact_us_url
				}
			}
        },
	}

</script>

<style type="text/css" scoped>
	.image_cover{
        background: url(https://resources.xycoder.com/dowa/openinbrowser.png) no-repeat center center fixed;
        background-size:100% 100%;
        background-attachment:fixed;

        height:100vh;
        width:100vw;
        margin-top: -50px;
    }
    .image_content{
        text-align: center;
        margin-top: 50px;
        display: flex;
        justify-content: center;
        align-content: center;
        align-items: center;
    }
    .file_item_content{
        width: 40%;
    }
    #click_btn{
        color: darkblue;
    }
</style>


// WEBPACK FOOTER //
// src/pages/profileDownload.vue